<template>
    <div :class="[{'zeborne ': isZeborne}, 'product-installation ' + colorClass]">
        <div v-for="install in product_installation" :key="install.id">
            <script type="application/ld+json">
                {
                    "@context": "https://schema.org",
                    "@type": "VideoObject",
                    "name": "{{ install.header_installation.title_header }} {{ install.header_installation.subtitle_header }}",
                    "description": "{{ install.header_installation.title_header }} {{ install.header_installation.subtitle_header }}",
                    "thumbnailUrl": [
                        "{{ baseURLStrapi+install.header_installation.img_video_header.url }}"
                    ],
                    "embedUrl": "{{ iframeVideoSrc }}"
                }
            </script>

            <!-- ********* Header installation ********** -->
            <div class="header-installation" id="header_installation" :style="[install.header_installation.img_header ? {'background-image': 'url(' + baseURLStrapi+install.header_installation.img_header.url + ')'} : '']"  data-scroll="header_installation">
                <div>
                    <div>
                        <p v-if="install.header_installation.text_video_header" class="text-video-header">{{ install.header_installation.text_video_header }}</p>
                        <p v-if="install.header_installation.title_header" class="title-header">{{ install.header_installation.title_header }}</p>
                        <p v-if="install.header_installation.subtitle_header" class="subtitle-header">{{ install.header_installation.subtitle_header }}</p>

                        <ObfuscateLink v-if="install.header_installation.link_btn_header" className="Button" :dataHref="install.header_installation.link_btn_header">
                            <template v-slot:content>
                                {{ install.header_installation.label_btn_header }}
                            </template>
                        </ObfuscateLink>
                    </div>
                    <div>
                        <div v-if="install.header_installation.img_video_header" class="video-wrapper" v-on:click="playVideo">
                            <img :src="baseURLStrapi+install.header_installation.img_video_header.url" alt="">
                            <div class="iframe" v-html="install.header_installation.link_video_header"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="subheader-installation">
                <div class="container">
                    <div>
                        <div class="title-subheader" v-if="install.subheader_installation.title_subheader" v-html="install.subheader_installation.title_subheader"></div>
                        <p v-if="install.subheader_installation.subtitle_subheader" class="subtitle-subheader">{{ install.subheader_installation.subtitle_subheader }}</p>
                    </div>
                    <div>
                        <div v-if="install.subheader_installation.list_subheader" class="list-subheader" v-html="install.subheader_installation.list_subheader"></div>
                    </div>
                </div>
            </div>

            <div v-if="install.content_installation" class="content-installation container">
                <div v-for="content in install.content_installation" :key="content.id">

                    <!-- ********* Simple text ********** -->
                    <div class="simple-text" v-if="content.__component === 'installation-component.simple-text-component'">
                        <div v-html="content.simple_text"></div>
                    </div>

                    <!-- ********* Heading ********** -->
                    <div class="heading" v-if="content.__component === 'installation-component.block-title-component'">
                        <div v-if="content.title_heading" class="title" v-html="content.title_heading"></div>
                        <div v-if="content.text_heading" class="text" v-html="content.text_heading"></div>
                    </div>

                    <!-- ********* Content list with image ********** -->
                    <div class="list-image" v-if="content.__component === 'installation-component.list-image-repeat-component'">
                        <div class="row-list" v-for="repeat in content.list_image_repeat" :key="repeat.id">
                            <div class="column-left">
                                <div class="img-wrapper">
                                    <p v-if="repeat.number_list" class="number">{{ repeat.number_list }}</p>
                                    <img v-if="repeat.image_list" :src="baseURLStrapi+repeat.image_list.url" alt="">
                                </div>
                                <p v-if="repeat.legend_img_list" class="legend">{{ repeat.legend_img_list }}</p>
                            </div>
                            <div>
                                <p v-if="repeat.overtitle_list" class="overtitle-list">{{ repeat.overtitle_list }}</p>
                                <p v-if="repeat.title_list" class="title-list">{{ repeat.title_list }}</p>
                                <div v-if="repeat.content_list" v-html="repeat.content_list"></div>
                                <p v-if="repeat.legend_img_list" class="legend-mobile mobileOnly">{{ repeat.legend_img_list }}</p>
                            </div>
                        </div>
                    </div>

                    <!-- ********* Warning text ********** -->
                    <div class="warning-text" v-if="content.__component === 'installation-component.warning-component'">
                        <svg xmlns="http://www.w3.org/2000/svg" id="exclamation" width="66.5" height="66.5" viewBox="0 0 66.5 66.5">
                            <g id="Groupe_159">
                                <g id="Groupe_158">
                                    <path id="Tracé_265" d="M33.25 0A33.25 33.25 0 1 0 66.5 33.25 33.231 33.231 0 0 0 33.25 0zm0 61.3A28.055 28.055 0 1 1 61.3 33.25 28.039 28.039 0 0 1 33.25 61.3z" class="color-icon"/>
                                </g>
                            </g>
                            <g id="Groupe_161" transform="translate(30.652 16.739)">
                                <g id="Groupe_160">
                                    <path id="Tracé_266" d="M238.6 128.877a2.6 2.6 0 0 0-2.6 2.6V148.2a2.6 2.6 0 1 0 5.2 0v-16.725a2.6 2.6 0 0 0-2.6-2.598z" class="color-icon" transform="translate(-236 -128.877)"/>
                                </g>
                            </g>
                            <g id="Groupe_163" transform="translate(29.743 41.843)">
                                <g id="Groupe_162">
                                    <circle id="Ellipse_188" cx="3.507" cy="3.507" r="3.507" class="color-icon"/>
                                </g>
                            </g>
                        </svg>
                        <div v-if="content.text_warning" v-html="content.text_warning"></div>
                    </div>
                </div>

                <div class="text-center mobileOnly">
                    <a v-if="install.header_installation.link_btn_header" class="Button" :href="install.header_installation.link_btn_header" :title="install.header_installation.label_btn_header">
                        {{ install.header_installation.label_btn_header }}
                    </a>
                </div>

            </div>

            <div v-if="install.footer_installation" id="footer_installation" class="footer-installation" data-scroll="footer_installation">
                <div class="container">
                    <div>
                        <div v-if="install.footer_installation.title_footer" class="bg-title-footer" v-html="install.footer_installation.title_footer"></div>
                        <div v-if="install.footer_installation.title_footer" class="title-footer" v-html="install.footer_installation.title_footer"></div>
                    </div>
                    <div>
                        <div class="icons-footer">
                            <img v-if="install.footer_installation.icon_footer_first" :src="baseURLStrapi+install.footer_installation.icon_footer_first.url" alt="">
                            <div v-if="install.footer_installation.text_icon_footer_first" class="text-icon" v-html="install.footer_installation.text_icon_footer_first"></div>
                        </div>
                        <div class="icons-footer">
                            <img v-if="install.footer_installation.icon_footer_second" :src="baseURLStrapi+install.footer_installation.icon_footer_second.url" alt="">
                            <div v-if="install.footer_installation.text_icon_footer_second" class="text-icon" v-html="install.footer_installation.text_icon_footer_second"></div>
                        </div>
                        <p v-if="install.footer_installation.desc_footer_first" class="description-footer">{{ install.footer_installation.desc_footer_first }}</p>
                        <div class="icons-footer">
                            <img v-if="install.footer_installation.icon_footer_third" :src="baseURLStrapi+install.footer_installation.icon_footer_third.url" alt="">
                            <div v-if="install.footer_installation.text_icon_footer_third" class="text-icon" v-html="install.footer_installation.text_icon_footer_third"></div>
                        </div>
                        <p v-if="install.footer_installation.desc_footer_second" class="description-footer">{{ install.footer_installation.desc_footer_second }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import "@/components/Product/ProductInstallation/ProductInstallation.scss";
    import ObfuscateLink from '@/components/ObfuscateLink/ObfuscateLink.vue';
    import axios from 'axios'

    export default {
        name: "ProductInstallation",

        components: {
            ObfuscateLink
        },

        props: {
            isObfuscate: true,
        },

        data() {
            return {
                product_installation: [],
                error: null,
                baseURLStrapi: process.env.VUE_APP_URL_STRAPI
            }
        },

        methods: {
            playVideo: function (element) {
                element.target.classList.add('play');
            }
        },

        computed: {
          ...mapGetters({ productInstallation: "getProductInstallation" }),
          ...mapGetters({ categoryId: "getCategoryId" }),
          ...mapGetters({ isZeborne: "isZeborne" }),

          colorClass: function () {
              if( this.categoryId == 18 ){ // Chauffe-eau électrique
                  return("blue");
              }
              else if ( this.categoryId == 17 ){ // Chaudière gaz
                  return("pink");
              }
              else if ( this.categoryId == 19 ){ // Radiateur électrique
                  return("yellow");
              }
              else if ( this.categoryId == 29 ){ // Sèche-serviettes
                  return("light-blue");
              }
              else if ( this.categoryId == 43 ){ // Chauffe-eau gaz
                  return("orange");
              }
              else if ( this.categoryId == 87 ){ // Chauffe-eau thermodynamique
                  return("green");
              }
              else if ( this.categoryId == 72 || this.categoryId == 120){ // Pompe à chaleur
                  return("green");
              }
              else if ( this.categoryId == 45 ){ // Bornes électriques
                  return("orange-zeborne");
              }
          }
        },

        async mounted () {
            try {
                const response = await axios.get(this.baseURLStrapi+'/installation-strates?category_id='+this.categoryId);
                this.product_installation = response.data;
                if(this.product_installation.length > 0) {
                  this.$root.$emit('stratesProductLoaded', [this.product_installation[0].header_installation, this.product_installation[0].footer_installation]);
                }

                // GET SRC OF IFRAME VIDEO
                const iframeVideo = this.product_installation[0].header_installation?.link_video_header;
                const parser = new DOMParser();
                const iframeVideoHtml = parser.parseFromString(iframeVideo, "text/html");
                const iframeVideoSrc = iframeVideoHtml.querySelector('iframe').getAttribute('src');
                this.iframeVideoSrc = iframeVideoSrc;

            } catch (error) {
                this.error = error;
            }
        }
    }
</script>
